export default __webpack_public_path__ + "static/sfc.b31425b9d1411b1897975617f862756d.png";